import { Controller } from "@hotwired/stimulus";

const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];

export default class extends Controller {
  static values = {
    pageName: String,
    thresholds: { type: Array, default: [50, 90] }
  };

  connect() {
    this.firedScrollThresholds = new Set();
    this.track("LandingPageViewed", this.baseProperties());

    this.handleScroll = this.handleScroll.bind(this);
    window.addEventListener("scroll", this.handleScroll, { passive: true });
  }

  disconnect() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll() {
    const viewportBottom = window.scrollY + window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;
    if (documentHeight <= 0) return;

    const percent = (viewportBottom / documentHeight) * 100;

    this.thresholdsValue.forEach((threshold) => {
      if (percent >= threshold && !this.firedScrollThresholds.has(threshold)) {
        this.firedScrollThresholds.add(threshold);
        this.track(`LandingScrolled${threshold}`, this.baseProperties());
      }
    });
  }

  ctaClicked(event) {
    const target = event.currentTarget;
    const { ctaLabel, ctaPosition } = target.dataset;

    const properties = {
      ...this.baseProperties(),
      cta_label: ctaLabel,
      cta_position: ctaPosition
    };

    this.track("LandingCTAClicked", properties);
  }

  baseProperties() {
    return {
      page_name: this.pageNameValue,
      ...this.utmFromUrl()
    };
  }

  utmFromUrl() {
    const params = new URLSearchParams(window.location.search);
    return UTM_KEYS.reduce((acc, key) => {
      const value = params.get(key);
      if (value) acc[key] = value;
      return acc;
    }, {});
  }

  track(eventName, properties) {
    if (typeof window.fbq === "function") {
      window.fbq("trackCustom", eventName, properties);
    }
    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({ event: eventName, ...properties });
    }
  }
}
